import { render, staticRenderFns } from "./JobVacancy.vue?vue&type=template&id=c879dc34"
import script from "./JobVacancy.vue?vue&type=script&lang=js"
export * from "./JobVacancy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports